import { yupResolver } from '@hookform/resolvers/yup'
import { Divider, Link as MUILink } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { useContext, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import {
  BlackText,
  GreyText,
  VerticallySelfCenteredDiv
} from 'components/common/common.style'
import { SignUpFormSchema } from 'services/validation/auth/signUp'
import { AuthModal } from './AuthModal'
import {
  CircleExclamationMarkIcon,
  TitleText,
  WarningContainer
} from './AuthModal.style'
import { AuthModalContext } from './AuthModalContext'
import { SignUpForm } from './SignUpForm'
import { SignUpFormValues } from './SignUpFormValues'

export const SignUpModal = () => {
  const {
    modalParams: { redirectUrl, email },
    setModalParams
  } = useContext(AuthModalContext)

  const { t } = useTranslation('authentication')
  const methods = useForm<SignUpFormValues>({
    resolver: yupResolver(SignUpFormSchema()),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  })

  useEffect(() => {
    if (email) {
      methods.setValue('email', email)
    }
  }, [email])

  return (
    <AuthModal modalState="SIGNUP">
      <TitleText>{t('register.title')}</TitleText>
      <GreyText>{t('register.description')}</GreyText>

      {email && (
        <WarningContainer>
          <VerticallySelfCenteredDiv style={{ width: '40px' }}>
            <CircleExclamationMarkIcon />
          </VerticallySelfCenteredDiv>
          <BlackText>
            {t('register.unknownEmail', {
              email
            })}
          </BlackText>
        </WarningContainer>
      )}

      <FormProvider {...methods}>
        <SignUpForm />
      </FormProvider>
      <GreyText>
        {t('register.signUpTerms.acceptTermsAndConditions')}
        <Link passHref href={'/terms-of-use'} target="_blank">
          <MUILink color="inherit">
            {t('register.signUpTerms.termsOfUse')}
          </MUILink>
        </Link>
        {t('register.signUpTerms.and')}
        <Link passHref href={'/privacy-policy'} target="_blank">
          <MUILink color="inherit" href={'/privacy-policy'}>
            {t('register.signUpTerms.privacyPolicy')}
          </MUILink>
        </Link>
        .
      </GreyText>

      <Divider
        sx={{
          width: '100%'
        }}
      />
      <GreyText>
        {t('register.alreadyAccount')}{' '}
        <MUILink
          style={{ cursor: 'pointer' }}
          onClick={() =>
            setModalParams({
              state: 'SIGNIN',
              redirectUrl
            })
          }
          color="inherit"
        >
          {t('register.signIn')}
        </MUILink>
      </GreyText>
    </AuthModal>
  )
}
